import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {
    getAuth,
    signInWithEmailAndPassword,
    signOut,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail as _sendPasswordResetEmail,
} from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getFirebaseEnvVar } from "utils/env";

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: getFirebaseEnvVar("API_KEY"),
    authDomain: getFirebaseEnvVar("AUTH_DOMAIN"),
    databaseURL: getFirebaseEnvVar("DATABASE_URL"),
    projectId: getFirebaseEnvVar("PROJECT_ID"),
    storageBucket: getFirebaseEnvVar("STORAGE_BUCKET"),
    messagingSenderId: getFirebaseEnvVar("MESSAGING_SENDER_ID"),
    appId: getFirebaseEnvVar("APP_ID"),
    measurementId: getFirebaseEnvVar("MEASUREMENT_ID"),
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);

// Initialize Auth
const auth = getAuth(firebase);

// Initialize Messaging
const messaging = getMessaging(firebase);

export const login = (email, password) => signInWithEmailAndPassword(auth, email, password);

export const logout = () => signOut(auth);

export const signUp = (email, password) => createUserWithEmailAndPassword(auth, email, password);

export const sendPasswordResetEmail = (email) => _sendPasswordResetEmail(auth, email);

export const db = () => getFirestore(firebase);

export const storage = getStorage(firebase);

export const initializeMessaging = async (twilioClient) => {
    try {
        try {
            await Notification.requestPermission();
        } catch (error) {
            console.error("An error occured during the Notifications permission request: ", error);
        }

        if ("serviceWorker" in navigator) {
            const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
            console.log("get token start...");
            const fcmToken = await getToken(messaging, {
                vapidKey: getFirebaseEnvVar("VAPID_KEY"),
                serviceWorkerRegistration: registration,
            });
            console.log("get token finished.", fcmToken);
            if (fcmToken) {
                localStorage.setItem("fcmToken", fcmToken);
                twilioClient.setPushRegistrationId("fcm", fcmToken);
            }
        }

        onMessage(messaging, (payload) => {
            twilioClient.handlePushNotification(payload);
        });
    } catch (error) {
        console.error("An error occured while initilizing Firebase Messaging: ", error);
    }
};

export default firebase;
